// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Navbar from "../Navbar/navbar";
// import Footer from "../Footer/footer";
// import FooterDoodles from "../Footer/footerDoodles";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import icons from "../../icons.config";
// import { loginApi } from "./loginApi"; // Import the API function

// const Login = () => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     try {
//       const data = await loginApi({ email_id: email, password }); // API call

//       console.log("Login successful:", data);
//       navigate("/");
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="flex items-center py-8 relative top-12 justify-center bg-tertiary overflow-hidden">
//         <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
//           <img src={icons.trendCircles} alt="Doodle Right" className="w-[50%] lg:w-[70%]" />
//         </div>
//         <div className="hidden lg:block absolute left-8 top-20 z-10">
//           <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
//         </div>
//         <div className="w-full max-w-3xl bg-tertiary px-10 relative lg:top-20 xl:top-8 py-12 z-30">
//           <h2 className="text-center text-3xl font-outfit text-primary1 mb-12">LOGIN</h2>
//           {error && <p className="text-red-500 text-center">{error}</p>}

//           <form className="space-y-1" onSubmit={handleSubmit}>
//             <div className="grid gap-6 md:grid-cols-2">
//               <div className="relative">
//                 <label htmlFor="email" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">
//                   EMAIL ADDRESS
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="Enter your email"
//                   className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
//                 />
//               </div>
//               <div className="relative">
//                 <label htmlFor="password" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">
//                   PASSWORD
//                 </label>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   id="password"
//                   name="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Enter your password"
//                   className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
//                 />
//                 <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
//                   {showPassword ? <FaEyeSlash className="text-secondary" /> : <FaEye className="text-secondary" />}
//                 </div>
//               </div>
//             </div>

//             <div className="flex items-center justify-end text-sm">
//               <a href="/forgot-password" className="text-hcolor underline">
//                 Forgot Password?
//               </a>
//             </div>

//             <div className="px-52">
//               <button type="submit" className="w-full bg-hcolor text-tertiary px-30 py-2 text-sm font-light hover:bg-tertiary hover:border-2 hover:text-hcolor focus:outline-none focus:ring-2 focus:ring-primary1 my-1">
//                 LOGIN
//               </button>
//             </div>

//             <div className="text-center space-y-6">
//               <p className="text-sm text-hcolor">
//                 Don’t have an account? <a href="/signup" className="text-primary1 underline">Sign Up</a>
//               </p>
//               <p className="text-sm text-hcolor">
//                 Having trouble logging in? <a href="/help" className="text-primary1 underline">Get Help</a>
//               </p>
//             </div>
//           </form>
//         </div>
//       </div>
//       <FooterDoodles />
//       <Footer />
//     </>
//   );
// };

// export default Login;


// // import React, { useState } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import Navbar from '../Navbar/navbar';
// // import Footer from '../Footer/footer';
// // import icons from '../../icons.config';
// // import { FaEye, FaEyeSlash } from 'react-icons/fa';
// // import FooterDoodles from '../Footer/footerDoodles';

// // const Login = () => {
// //   const [showPassword, setShowPassword] = useState(false);
// //   const [email, setEmail] = useState('');
// //   const [password, setPassword] = useState('');
// //   const [error, setError] = useState('');
// //   const navigate = useNavigate();

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setError('');
  
// //     try {
// //       const response = await fetch('http://65.1.244.239:3001/api/auth/user/login-user', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({ email_id: email, password }), // Changed "email" to "email_id"
// //       });
  
// //       const data = await response.json();
  
// //       if (!response.ok) {
// //         throw new Error(data.message || 'Login failed');
// //       }
  
// //       console.log('Login successful:', data);
// //       navigate('/');
// //     } catch (err) {
// //       setError(err.message);
// //     }
// //   };
  
  

// //   return (
// //     <>
// //       <Navbar />
// //       <div className="flex items-center py-8 relative top-12 justify-center bg-tertiary overflow-hidden">
// //         <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
// //           <img src={icons.trendCircles} alt="Doodle Right" className="w-[50%] lg:w-[70%]" />
// //         </div>
// //         <div className="hidden lg:block absolute left-8 top-20 z-10">
// //           <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
// //         </div>
// //         <div className="w-full max-w-3xl bg-tertiary px-10 relative lg:top-20 xl:top-8 py-12 z-30">
// //           <h2 className="text-center text-3xl font-outfit text-primary1 mb-12">LOGIN</h2>
// //           {error && <p className="text-red-500 text-center">{error}</p>}

// //           <form className="space-y-1" onSubmit={handleSubmit}>
// //             <div className="grid gap-6 md:grid-cols-2">
// //               <div className="relative">
// //                 <label htmlFor="email" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">EMAIL ADDRESS</label>
// //                 <input
// //                   type="email"
// //                   id="email"
// //                   name="email"
// //                   value={email}
// //                   onChange={(e) => setEmail(e.target.value)}
// //                   placeholder="Enter your email"
// //                   className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
// //                 />
// //               </div>
// //               <div className="relative">
// //                 <label htmlFor="password" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">PASSWORD</label>
// //                 <input
// //                   type={showPassword ? 'text' : 'password'}
// //                   id="password"
// //                   name="password"
// //                   value={password}
// //                   onChange={(e) => setPassword(e.target.value)}
// //                   placeholder="Enter your password"
// //                   className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
// //                 />
// //                 <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
// //                   {showPassword ? <FaEyeSlash className="text-secondary" /> : <FaEye className="text-secondary" />}
// //                 </div>
// //               </div>
// //             </div>

// //             <div className="flex items-center justify-end text-sm">
// //               <a href="/forgot-password" className="text-hcolor underline">Forgot Password?</a>
// //             </div>

// //             <div className="px-52">
// //               <button type="submit" className="w-full bg-hcolor text-tertiary px-30 py-2 text-sm font-light hover:bg-primary2 focus:outline-none focus:ring-2 focus:ring-primary1 my-1">
// //                 LOGIN
// //               </button>
// //             </div>

// //             <div className="text-center space-y-6">
// //               <p className="text-sm text-hcolor">Don’t have an account? <a href="/signup" className="text-primary1 underline">Sign Up</a></p>
// //               <p className="text-sm text-hcolor">Having trouble logging in? <a href="/help" className="text-primary1 underline">Get Help</a></p>
// //             </div>
// //           </form>
// //         </div>
// //       </div>
// //       <FooterDoodles />
// //       <Footer />
// //     </>
// //   );
// // };

// // export default Login;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../store/authSlice";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import FooterDoodles from "../Footer/footerDoodles";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import icons from "../../icons.config";
import { loginApi } from "../../Providers/authProvider"; // ✅ Import from authProvider

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const handleLogin = (userData) => {
    if (!userData.token) {
      console.error("Login successful but token is missing!", userData);
      setError("Token is missing from response.");
      return;
    }
  
    localStorage.setItem("authToken", userData.token); // ✅ Store token in localStorage
    dispatch(login({ token: userData.token, user: userData }));
    
    console.log("User logged in, token saved:", localStorage.getItem("authToken")); 
    navigate("/"); // Redirect to home/profile
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setPhone(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const data = await loginApi({ mobile_number: phone, password }); // ✅ Using loginApi from authProvider
      console.log("Login successful:", data);
      handleLogin(data);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="flex items-center py-8 relative top-12 justify-center bg-tertiary overflow-hidden">
        <div className="absolute -right-52 -top-12 lg:-right-32 lg:-top-16 z-40">
          <img src={icons.trendCircles} alt="Doodle Right" className="w-[50%] lg:w-[70%]" />
        </div>
        <div className="hidden lg:block absolute left-8 top-20 z-10">
          <img src={icons.aboutUsFlower} alt="Doodle Left" className="w-[77%]" />
        </div>
        <div className="w-full max-w-3xl bg-tertiary px-10 relative lg:top-20 xl:top-8 py-12 z-30">
          <h2 className="text-center text-3xl font-outfit text-primary1 mb-12">LOGIN</h2>
          {error && <p className="text-red-500 text-center">{error}</p>}

          <form className="space-y-1" onSubmit={handleSubmit}>
            <div className="grid gap-6 md:grid-cols-2">
              <div className="relative">
                <label htmlFor="phone" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">
                  PHONE NUMBER
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={phone}
                  onChange={handlePhoneChange}
                  placeholder="Enter your phone number"
                  className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
                />
              </div>
              <div className="relative">
                <label htmlFor="password" className="absolute left-3 px-2 bg-tertiary text-primary1 text-md font-medium transform -translate-y-4 scale-75 top-1">
                  PASSWORD
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="w-full px-4 py-3 border rounded-md bg-tertiary text-primary1 text-xs focus:outline-none focus:ring-2 focus:ring-primary1"
                />
                <div className="absolute inset-y-0 right-3 flex items-center cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <FaEyeSlash className="text-secondary" /> : <FaEye className="text-secondary" />}
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end text-sm">
              <a href="/forgot-password" className="text-hcolor underline">
                Forgot Password?
              </a>
            </div>

            <div className="px-52">
              <button type="submit" className="w-full bg-hcolor text-tertiary px-30 py-2 text-sm font-light hover:bg-tertiary hover:border-2 hover:text-hcolor focus:outline-none focus:ring-2 focus:ring-primary1 my-1">
                LOGIN
              </button>
            </div>

            <div className="text-center space-y-6">
              <p className="text-sm text-hcolor">
                Don’t have an account? <a href="/signup" className="text-primary1 underline">Sign Up</a>
              </p>
              <p className="text-sm text-hcolor">
                Having trouble logging in? <a href="/help" className="text-primary1 underline">Get Help</a>
              </p>
            </div>
          </form>
        </div>
      </div>
      <FooterDoodles />
      <Footer />
    </>
  );
};

export default Login;
